/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.communication.subscriptions.rpc.CommunicationSubscriptionsDefinitionRpc
 */

/**
 *  Mutable fields for a subscription definition update. Excludes immutable fields (channel,
 *  defaultSubscription, internal) and server-managed fields (portalId, createdAt, updatedAt).
 *  <p>All fields are applied on update — omitting an Optional field clears it in the database.
 *  Callers should send the full mutable state, not partial updates.
 *  <p>Exception: {@code primaryLanguage} uses merge-on-update semantics. When omitted, the server
 *  preserves the existing value rather than clearing it, because the downstream validator rejects
 *  empty primary languages.
 */

export const getDefinitionsRpc = {
  serviceName: 'com.hubspot.communication.subscriptions.rpc.CommunicationSubscriptionsDefinitionRpc',
  rpcName: 'getDefinitions',
  auth: 'app',
  fingerprint: 'UCIGdzq3X5Lj9m5INw3GKgRHQBUV1IKF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getDefinitionByIdRpc = {
  serviceName: 'com.hubspot.communication.subscriptions.rpc.CommunicationSubscriptionsDefinitionRpc',
  rpcName: 'getDefinitionById',
  auth: 'app',
  fingerprint: '7Abf1XV2WT-lrzYAG1Ju7wRHQBUV1IKF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getDefinitionByKeyRpc = {
  serviceName: 'com.hubspot.communication.subscriptions.rpc.CommunicationSubscriptionsDefinitionRpc',
  rpcName: 'getDefinitionByKey',
  auth: 'app',
  fingerprint: 'tCAQzfYR5gmlrzYAG1Ju7wRHQBUV1IKF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getDefinitionsByChannelRpc = {
  serviceName: 'com.hubspot.communication.subscriptions.rpc.CommunicationSubscriptionsDefinitionRpc',
  rpcName: 'getDefinitionsByChannel',
  auth: 'app',
  fingerprint: 'jTz8ayHTpgvj9m5INw3GKgRHQBUV1IKF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getProcessesAndOperationsRpc = {
  serviceName: 'com.hubspot.communication.subscriptions.rpc.CommunicationSubscriptionsDefinitionRpc',
  rpcName: 'getProcessesAndOperations',
  auth: 'app',
  fingerprint: '1Y2xLJeDfHGsqKfcA2QkJgRHQBUV1IKF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createDefinitionRpc = {
  serviceName: 'com.hubspot.communication.subscriptions.rpc.CommunicationSubscriptionsDefinitionRpc',
  rpcName: 'createDefinition',
  auth: 'app',
  fingerprint: 'HM7FWnqdZWulrzYAG1Ju7wRHQBUV1IKF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateDefinitionsRpc = {
  serviceName: 'com.hubspot.communication.subscriptions.rpc.CommunicationSubscriptionsDefinitionRpc',
  rpcName: 'updateDefinitions',
  auth: 'app',
  fingerprint: 'i4VfvqSQjGOmETwinV1kKgRHQBUV1IKF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateDefinitionPositionsRpc = {
  serviceName: 'com.hubspot.communication.subscriptions.rpc.CommunicationSubscriptionsDefinitionRpc',
  rpcName: 'updateDefinitionPositions',
  auth: 'app',
  fingerprint: '4fBRINnClRimETwinV1kKgRHQBUV1IKF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const toggleActiveStateRpc = {
  serviceName: 'com.hubspot.communication.subscriptions.rpc.CommunicationSubscriptionsDefinitionRpc',
  rpcName: 'toggleActiveState',
  auth: 'app',
  fingerprint: 'NmBhy9DiRyilrzYAG1Ju7wRHQBUV1IKF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const moveDefinitionToBusinessUnitRpc = {
  serviceName: 'com.hubspot.communication.subscriptions.rpc.CommunicationSubscriptionsDefinitionRpc',
  rpcName: 'moveDefinitionToBusinessUnit',
  auth: 'app',
  fingerprint: 'qPCAZa7gWg7j9m5INw3GKgRHQBUV1IKF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getDefinitionByIdCrossHubletRpc = {
  serviceName: 'com.hubspot.communication.subscriptions.rpc.CommunicationSubscriptionsDefinitionRpc',
  rpcName: 'getDefinitionByIdCrossHublet',
  auth: 'app',
  fingerprint: '7Abf1XV2WT-lrzYAG1Ju7wRHQBUV1IKF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};